import { useState, useEffect } from "react";
import { MutantApiService } from "../services/MutantApiService";
import store from "../../app/store/store";

export const useMaintenanceMode = () => {
    const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
    const api = new MutantApiService();
    const user = store.getState().auth?.user;

    useEffect(() => {
        if (!user) return;

        const loadData = async () => {
            try {
                const settings = await api.makeHttpRequest({
                    url: `/settings`,
                    method: "GET"
                });
                const maintenanceModeActive = settings.maintenanceMode && user?.role !== "ADMIN";
                setIsMaintenanceMode(maintenanceModeActive);
            } catch (error) {
                console.error("Erro ao verificar o modo de manutenção", error);
            }
        };

        loadData();
        const intervalId = setInterval(loadData, 30000); // Executa loadData a cada 30 segundos

        return () => clearInterval(intervalId); // Limpa o intervalo quando o componente for desmontado
    }, [user, api]);

    return isMaintenanceMode;
};
